const sortedTable = (tableCols, tableRows) => {
    let columnsLength = tableCols.length;
    let hiddenCols = [];
    let plotReadyColumns = [];
    let plotReadyRows = []

    for (let col of tableCols) {
        let obj = {
            "key": col.key + "_#",
            "label": col.label + "_#"
        }
        hiddenCols.push(obj);
    }

    plotReadyColumns = tableCols.concat(hiddenCols);

    for (let [idx, ds] of tableRows.entries()) {
        for (let [idy, obj] of Object.entries(ds)) {
            ds[idy + "_#"] = obj;
            if (obj == "") {
                ds[idy] = "-";
                ds[idy + "_#"] = "0";
            }
        }
        plotReadyRows.push(ds);
    }

    let plotReadyColumnDefs = [];
    for (let i = 0; i < columnsLength; i++) {
        let obj1 = { "orderData": i + columnsLength, "targets": i };
        let obj2 = { "visible": false, "targets": i + columnsLength };
        plotReadyColumnDefs.push(obj1);
        plotReadyColumnDefs.push(obj2);
    }

    return {
        plotReadyColumns,
        plotReadyRows,
        plotReadyColumnDefs
    }
}

export default sortedTable;